export default "__VITE_ASSET__B2stYTot__"